import TripEntryModalView from './trip_entry_modal_view';

export default class TripEntryFormView {
  constructor() {
    this.observeCreateClick()
    this.observeHoverEdit()
    this.observeDelete()
  }

  ////////////////////////////////////////////////////////////////////////////////
  // Observers
  ////////////////////////////////////////////////////////////////////////////////
  observeCreateClick() {
    document.querySelector("#new_trip_entry")
      .addEventListener("click", (ev) => {
      ev.preventDefault();
      const url = ev.currentTarget.href

      this.modalView = new TripEntryModalView({
        parentView: this,
        title: "Add New Detail",
        submitButtonText: "Create Detail",
        url,
      })
    })
  }

  observeHoverEdit() {
    $(document).on('click', '#trip_entries > table td:not(.actions)', (e) => {
      const $tr      = $(e.currentTarget).parents('tr');
      const editable = $tr.data('editable');
      const url      = $tr.data('edit-url');

      if (editable) {
        this.modalView = new TripEntryModalView({
          parentView: this,
          url: url,
          title: "Editing Detail",
          submitButtonText: "Update Detail",
        })
      }
    })
  }

  observeDelete() {
    $(document).on("click", "#trip_entries table td.actions a.destroy", (e) => {
      let actuallyDelete = confirm("Are you sure you want to delete this line? You can't undo this deletion -- it is permanent.")

      if (actuallyDelete) {
        var $target = $(e.currentTarget)

        $.ajax({
          url:      $target.attr("href"),
          // data:     { _method: "delete" },
          type:     "DELETE",
          dataType: "json",
          success:  (data) => {
            console.log("Completed with", data)
            this.updateCompositeFields(data.composite_html)
            $target.parents("tr").remove()
          },
        })
      }

      return false
    });
  }

  ////////////////////////////////////////////////////////////////////////////////
  // Modal Management
  ////////////////////////////////////////////////////////////////////////////////
  formDidSubmitSuccessfully(status, data) {
    (status == 201) ?
      this.appendToTable(data.row_html) :
      this.replaceTableRow(data.row_id, data.row_html)

    this.updateCompositeFields(data.composite_html)
  }

  updateCompositeFields(html) {
    $("#trip #fiscal").html(html)
  }

  appendToTable(html) {
    $("#trip_entries > table").append(html)
  }

  replaceTableRow(selector, html) {
    $("#trip_entries > table").find(selector).replaceWith(html)
  }
}
